var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"8b0a2558f0b61e05dba9e2fdfdb05da7bd3abb68"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["javascript-react@farmec-sa"]={id:"8b0a2558f0b61e05dba9e2fdfdb05da7bd3abb68"};
      